// extracted by css-extract-rspack-plugin
export default {"popularSearches":"_c4e3ae99","popularSearchesCategory":"_61beeba9"};